import React from "react";
import Select from "react-select";
import { Card, CardBody, CardTitle, Row, Col, Label } from "reactstrap";

const YourComponent = ({ title, data, annee, setAnnee, filtre }) => {
  const layout = localStorage.getItem("layoutMode");
  const handleAnneeNChange = (e) => {
    setAnnee(e);
  };
  const style = { fontFamily: "sans-serif", paddingTop: "10px" };
  return (
    <>
      <CardTitle
        style={{
          fontFamily: "sans-serif",
          color: "#555b21",
          paddingLeft: 15,
          paddingTop: 15,
        }}
        className="mb-3"
      >
        {title}
      </CardTitle>
      <Card>
        <Row>
          <Col sm={8}></Col>
          <Col sm={4} className="d-flex justify-content-end align-items-end">
            <Label>Année :</Label>
            <div
              style={{
                paddingLeft: 10,
                paddingTop: 10,
                paddingRight: "inherit",
              }}
            >
              <Select
                defaultValue={annee}
                isClearable={false}
                isSearchable={false}
                className="react-select-container"
                menuPosition="fixed"
                classNamePrefix="react-select"
                options={filtre}
                onChange={handleAnneeNChange}
                styles={{
                  control: (provided) => ({ ...provided, width: 150 }),
                }}
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <Row className="mb-3 mt-3 m-lg-1">
              <>
                {title.includes("CGP") ? (
                  <Row>
                    <Col md="12">
                      <p className="text-muted fw-medium">Total de vos CGPs</p>
                    </Col>
                  </Row>
                ) : null}
                {data.map((item, index) => (
                  <>
                    {item?.text ? (
                      <p style={{ paddingLeft: 40 }}>{item.text}</p>
                    ) : !item.partenaire && item.label ? (
                      <>
                        <Col md="3" key={"_col_" + index}>
                          <Card className="mini-stats-wid">
                            <CardBody>
                              <div className="d-flex">
                                <div className="flex-grow-1">
                                  <p className="text-muted fw-medium">
                                    {item.label}
                                  </p>
                                  <h2 className="mb-0">
                                    {item?.value?.toLocaleString("fr-FR", {
                                      style: "currency",
                                      currency: "EUR",
                                      minimumFractionDigits: 0,
                                      minimumFractionDigits: 0,
                                    })}
                                  </h2>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ))}
                {data.map((item, index) => (
                  <>
                    {item.partenaire ? (
                      <>
                        <Row>
                          <Col
                            md="12"
                            style={{
                              borderTop: `1px solid ${
                                layout == "dark" ? "white" : "black"
                              }`,
                              paddingTop: "1em",
                            }}
                          >
                            <p className="text-muted fw-medium">
                              {item.partenaire}
                            </p>
                          </Col>
                        </Row>
                        <Row>
                          {item?.data.map((pItem, pIndex) => (
                            <>
                              <Col md="3" key={"_col_" + pIndex}>
                                <Card className="mini-stats-wid">
                                  <CardBody>
                                    <div className="d-flex">
                                      <div className="flex-grow-1">
                                        <p className="text-muted fw-medium">
                                          {pItem.label}
                                        </p>
                                        <h2 className="mb-0">
                                          {pItem?.value?.toLocaleString(
                                            "fr-FR",
                                            {
                                              style: "currency",
                                              currency: "EUR",
                                              minimumFractionDigits: 0,
                                              minimumFractionDigits: 0,
                                            }
                                          )}
                                        </h2>
                                      </div>
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col>
                            </>
                          ))}
                        </Row>
                      </>
                    ) : null}
                  </>
                ))}
              </>
            </Row>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default YourComponent;
